import React from 'react';
// @ts-ignore
import { ProGallery } from 'pro-gallery';
// @ts-ignore
import { getResizeMediaUrl, Wix } from '@wix/photography-client-lib';
import '../styles/gallery.global.scss';
import { utils } from '../utils';
export var ProGalleryWrapper = function (props) {
    var container = props.container;
    var items = props.items;
    var eventsListener = props.eventsListener;
    // TODO when we have staticMediaUrls in the iframes we should pass them here to getResizedMediaUrl
    var createMediaUrl = getResizeMediaUrl();
    var getScrollingElement = function () {
        return {
            addEventListener: function (eventName, callback) {
                // console.count('PROGALLERY [visibilities] - Wix.addEventListener: ' + this.id);
                eventName = eventName.toUpperCase();
                // @ts-ignore
                Wix.addEventListener(eventName, callback);
            },
            removeEventListener: function (eventName, callback) {
                // console.count('PROGALLERY [visibilities] - Wix.removeEventListener: ' + this.id);
                // @ts-ignore
                Wix.removeEventListener(eventName.toUpperCase(), callback);
            },
            scrollTo: function (x, y) {
                if (!utils.isEditor()) {
                    // @ts-ignore
                    Wix.scrollTo(x, y);
                }
            },
        };
    };
    var customComponents = props.customComponents;
    return (React.createElement(ProGallery, { totalItemsCount: props.totalItemsCount, container: container, key: props.key, id: props.id, scrollingElement: getScrollingElement(), items: items, options: props.options, settings: props.settings, eventsListener: eventsListener, activeIndex: props.activeIndex, isInDisplay: props.isInDisplay, viewMode: props.viewMode, createMediaUrl: createMediaUrl, customComponents: customComponents }));
};
//# sourceMappingURL=proGalleryWrapper.js.map